import { render, staticRenderFns } from "./LpuRating.vue?vue&type=template&id=e9f46896&scoped=true&"
import script from "./LpuRating.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuRating.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuRating.vue?vue&type=style&index=0&id=e9f46896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f46896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f46896')) {
      api.createRecord('e9f46896', component.options)
    } else {
      api.reload('e9f46896', component.options)
    }
    module.hot.accept("./LpuRating.vue?vue&type=template&id=e9f46896&scoped=true&", function () {
      api.rerender('e9f46896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/LpuRating.vue"
export default component.exports